import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { IoMdTrendingUp, IoMdTrendingDown } from "react-icons/io";
import { useMarketSnapshot } from "../../context/MarketSnapshotContext";
import useLivePrices from "../../hooks/useLivePrices";
import { useVariant } from "../../hooks/useVariant";
import Marquee from "react-fast-marquee";

// const IndexTabs = () => {
//   const navigate = useNavigate();

//   const {
//     dashboardIndexTab,
//     loadDashboardIndexMarket,
//     resetDashboardMarketData,
//   } = useMarketSnapshot();

//   if (!dashboardIndexTab?.length) return null;

//   return (
//     <div className="index-chip-container">
//       {dashboardIndexTab.map((item) => {
//         const isPositive = Number(item?.percent_change) >= 0;

//         return (
//           <button
//             key={item?.index_name}
//             className="index-chip"
//             onClick={async () => {
//               try {
//                 resetDashboardMarketData();

//                 await loadDashboardIndexMarket({
//                   indexName: item?.index_name,
//                 });

//                 navigate(`/indexPage/${item?.index_name}`);
//               } catch (err) {
//                 console.error("Index navigation failed", err);
//               }
//             }}
//             style={{
//               background: isPositive ? "#ecfdf5" : "#fef2f2",

//               border: `1px solid ${isPositive ? "#86efac" : "#fca5a5"}`,
//             }}
//           >
//             <span className="index-chip-name">{item?.index_name}</span>

//             <span
//               className={isPositive ? "index-chip-green" : "index-chip-red"}
//             >
//               ₹{item?.last_price ?? "—"}
//             </span>

//             <span
//               className={isPositive ? "index-chip-green" : "index-chip-red"}
//             >
//               {isPositive ? "+" : ""}
//               {item?.percent_change ?? 0}%
//               {isPositive ? <IoMdTrendingUp size={18}/> : <IoMdTrendingDown size={18}/>}
//             </span>
//           </button>
//         );
//       })}
//     </div>
//   );
// };

//previously working code
// const IndexTabs = () => {
//   const navigate = useNavigate();
//   const {
//     dashboardIndexTab,
//     loadDashboardIndexMarket,
//     resetDashboardMarketData,
//   } = useMarketSnapshot();

//   const { prices: livePrices, isLive, subscribeSymbols } = useLivePrices();

//   // Subscribe index names when tabs load
//   useEffect(() => {
//     if (!dashboardIndexTab?.length) return;

//     const indexNames = dashboardIndexTab.map((t) => t.index_name);
//     subscribeSymbols(indexNames);
//   }, [dashboardIndexTab]);

//   if (!dashboardIndexTab?.length) return null;

//   return (
//     <div className="index-chip-container">
//       {dashboardIndexTab.map((item) => {
//         const live = livePrices[item?.index_name];

//         // Live price falls back to DB price
//         const lastPrice = live?.ltp || item?.last_price;

//         // Live percent change falls back to DB
//         const percentChange =
//           live?.percentChange || Number(item?.percent_change ?? 0);

//         const isPositive = percentChange >= 0;

//         return (
//           <button
//             key={item?.index_name}
//             className="index-chip"
//             onClick={async () => {
//               try {
//                 resetDashboardMarketData();
//                 await loadDashboardIndexMarket({
//                   indexName: item?.index_name,
//                 });
//                 navigate(`/indexPage/${item?.index_name}`);
//               } catch (err) {
//                 console.error("Index navigation failed", err);
//               }
//             }}
//             style={{
//               background: isPositive ? "#ecfdf5" : "#fef2f2",
//               border: `1px solid ${isPositive ? "#86efac" : "#fca5a5"}`,
//             }}
//           >
//             <span className="index-chip-name">{item?.index_name}</span>
//             <div className="index-chip-div">
//               <span
//                 className={isPositive ? "index-chip-green" : "index-chip-red"}
//               >
//                 ₹{lastPrice ?? "—"}
//               </span>

//               {/* <span
//                 className={isPositive ? "index-chip-green" : "index-chip-red"}
//               >
//                 {isPositive ? "+" : ""}
//                 {percentChange?.toFixed?.(2) ?? "0.00"}%
//                 {isPositive ? (
//                   <IoMdTrendingUp size={18} />
//                 ) : (
//                   <IoMdTrendingDown size={18} />
//                 )}

//                  {Number(percent_change) >= 0 ? "▲" : "▼"}
//               </span> */}
//               <span
//                 className={isPositive ? "index-chip-green" : "index-chip-red"}
//               >
//                 {isPositive ? "+" : ""}
//                 {percentChange?.toFixed?.(2) ?? "0.00"}%
//                 {/* Desktop / large screen icon */}
//                 <span className="trend-icon-desktop">
//                   {isPositive ? (
//                     <IoMdTrendingUp size={18} />
//                   ) : (
//                     <IoMdTrendingDown size={18} />
//                   )}
//                 </span>
//                 {/* Mobile triangle */}
//                 <span className="trend-icon-mobile">
//                   {isPositive ? "▲" : "▼"}
//                 </span>
//               </span>
//             </div>

//             {/* Optional: tiny dot to show live status */}
//             {live && (
//               <span
//                 style={{
//                   width: 6,
//                   height: 6,
//                   borderRadius: "50%",
//                   background: "#22c55e",
//                   display: "inline-block",
//                   marginLeft: 4,
//                 }}
//               />
//             )}
//           </button>
//         );
//       })}
//     </div>
//   );
// };

// const IndexTabs = () => {
//   const navigate = useNavigate();
//   const variant = useVariant(); // ← your existing hook
//   const {
//     dashboardIndexTab,
//     loadDashboardIndexMarket,
//     resetDashboardMarketData,
//     getAllIndexTabs,
//     allIndexTabs,
//     indexTabsError,
//     indexTabsLoading,
//   } = useMarketSnapshot();

//   const { prices: livePrices, isLive, subscribeSymbols } = useLivePrices();

//   useEffect(() => {
//     if (!dashboardIndexTab?.length) return;
//     const indexNames = dashboardIndexTab.map((t) => t.index_name);
//     subscribeSymbols(indexNames);
//     getAllIndexTabs();
//   }, [dashboardIndexTab]);
//   console.log("Index tabs from db", allIndexTabs);

//   if (!dashboardIndexTab?.length) return null;

//   const renderChips = () =>
//     dashboardIndexTab.map((item) => {
//       const live = livePrices[item?.index_name];
//       const lastPrice = live?.ltp || item?.last_price;
//       const percentChange =
//         live?.percentChange || Number(item?.percent_change ?? 0);
//       const isPositive = percentChange >= 0;

//       return (
//         <button
//           key={item?.index_name}
//           className="index-chip"
//           onClick={async () => {
//             try {
//               resetDashboardMarketData();
//               navigate(`/indexPage/${item?.index_name}`);
//               // await loadDashboardIndexMarket({ indexName: item?.index_name });
//             } catch (err) {
//               console.error("Index navigation failed", err);
//             }
//           }}
//           style={{
//             background: isPositive ? "#ecfdf5" : "#fef2f2",
//             border: `1px solid ${isPositive ? "#86efac" : "#fca5a5"}`,
//           }}
//         >
//           <span className="index-chip-name">{item?.index_name}</span>
//           <div className="index-chip-div">
//             <span
//               className={isPositive ? "index-chip-green" : "index-chip-red"}
//             >
//               ₹{lastPrice ?? "—"}
//             </span>
//             <span
//               className={isPositive ? "index-chip-green" : "index-chip-red"}
//             >
//               {isPositive ? "+" : ""}
//               {percentChange?.toFixed?.(2) ?? "0.00"}%
//               <span className="trend-icon-desktop">
//                 {isPositive ? (
//                   <IoMdTrendingUp size={18} />
//                 ) : (
//                   <IoMdTrendingDown size={18} />
//                 )}
//               </span>
//               <span className="trend-icon-mobile">
//                 {isPositive ? "▲" : "▼"}
//               </span>
//             </span>
//           </div>
//           {live && (
//             <span
//               style={{
//                 width: 6,
//                 height: 6,
//                 borderRadius: "50%",
//                 background: "#22c55e",
//                 display: "inline-block",
//                 marginLeft: 4,
//               }}
//             />
//           )}
//         </button>
//       );
//     });

//   return (
//     <div className="index-chip-container">
//       {variant === "mobile" ? (
//         <Marquee
//           speed={40}
//           pauseOnHover
//           pauseOnClick
//           gradient
//           gradientWidth={20}
//           gradientColor="#ffffff"
//           className="index-marquee"
//         >
//           {renderChips()}
//         </Marquee>
//       ) : (
//         renderChips()
//       )}
//     </div>
//   );
// };
const IndexTabs = () => {
  const navigate = useNavigate();
  const variant = useVariant();
  const {
    loadDashboardIndexMarket,
    resetDashboardMarketData,
    getAllIndexTabs,
    allIndexTabs,
    indexTabsLoading,
  } = useMarketSnapshot();

  const { prices: livePrices, subscribeSymbols } = useLivePrices();

  useEffect(() => {
    getAllIndexTabs();
  }, []);

  useEffect(() => {
    if (!allIndexTabs?.data?.length) return;
    const indexNames = allIndexTabs?.data?.map((t) => t.index_name);
    subscribeSymbols(indexNames);
  }, [allIndexTabs]);
  // console.log("All index tabs", allIndexTabs);

  if (!allIndexTabs?.data?.length) return null;

  const renderChips = () =>
    allIndexTabs?.data?.map((item) => {
      const live = livePrices[item?.index_name];
      const lastPrice = live?.ltp || item?.last_price;
      const prevClose = item?.prev_close;

      // Recalculate change from prev_close when live
      const percentChange =
        live?.ltp && prevClose
          ? Number((((live.ltp - prevClose) / prevClose) * 100).toFixed(2))
          : (item?.percent_change ?? 0);

      const dayChange =
        live?.ltp && prevClose
          ? Number((live.ltp - prevClose).toFixed(2))
          : (item?.dayChange ?? 0);

      const isPositive = percentChange >= 0;

      return (
        <button
          key={item?.index_name}
          className="index-chip"
          onClick={async () => {
            try {
              resetDashboardMarketData();
              navigate(`/indexPage/${item?.index_name}`);
            } catch (err) {
              console.error("Index navigation failed", err);
            }
          }}
          style={{
            background: isPositive ? "#ecfdf5" : "#fef2f2",
            border: `1px solid ${isPositive ? "#86efac" : "#fca5a5"}`,
          }}
        >
          <span className="index-chip-name">{item?.index_name}</span>
          <div className="index-chip-div">
            <span
              className={isPositive ? "index-chip-green" : "index-chip-red"}
            >
              ₹{lastPrice ?? "—"}
            </span>
            <span
              className={isPositive ? "index-chip-green" : "index-chip-red"}
            >
              {isPositive ? "+" : ""}
              {percentChange?.toFixed?.(2) ?? "0.00"}%
              <span className="trend-icon-desktop">
                {isPositive ? (
                  <IoMdTrendingUp size={18} />
                ) : (
                  <IoMdTrendingDown size={18} />
                )}
              </span>
              <span className="trend-icon-mobile">
                {isPositive ? "▲" : "▼"}
              </span>
            </span>
          </div>
          {live && (
            <span
              style={{
                width: 6,
                height: 6,
                borderRadius: "50%",
                background: "#22c55e",
                display: "inline-block",
                marginLeft: 4,
              }}
            />
          )}
        </button>
      );
    });

  return (
    <div className="index-chip-container">
      {variant === "mobile" ? (
        <Marquee
          speed={40}
          pauseOnHover
          pauseOnClick
          gradient
          gradientWidth={20}
          gradientColor="#ffffff"
          className="index-marquee"
        >
          {renderChips()}
        </Marquee>
      ) : (
        renderChips()
      )}
    </div>
  );
};

export default IndexTabs;
